import * as React from 'react'

const SvgUploadIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 10.625l.881.881L9.375 6.77V18.75h1.25V6.769l4.744 4.737.881-.881L10 4.375l-6.25 6.25zM3.75 5V2.5h12.5V5h1.25V2.5c0-.69-.56-1.25-1.25-1.25H3.75c-.69 0-1.25.56-1.25 1.25V5h1.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgUploadIcon
